<template>
    <div class="tw-container tw-mx-auto">
        <div class="tw-flex tw-justify-center">
            <div class="tw-w-full md:tw-w-2/3 tw-py-4">
                <h3 class="tw-text-white">{{ __('terms.title') }}</h3>
            </div>
        </div>
        <div class="tw-flex tw-justify-center">
            <div class="tw-w-full md:tw-w-2/3">
                <div id="purchase__terms-block" class="tw-text-white" v-html="__('terms.body')"></div>
            </div>
        </div>
        <form @submit="formWillSubmit">
            <div class="tw-flex tw-justify-center">
                <div class="tw-w-full md:tw-w-2/3 tw-py-4">
                    <div class="tw-flex tw-mt-2">
                        <div class="tw-mr-2">
                            <input
                                class="tw-h-5 tw-w-5 tw-rounded"
                                type="checkbox"
                                id="agree_terms_conditions"
                                :class="{ 'tw-border-red-500': errors.agree_terms_conditions }"
                                v-model="agreeTermsConditions" 
                            >
                            <label class="tw-ml-2" for="agree_terms_conditions"></label>
                            <span v-show="errors.agree_terms_conditions" class="tw-text-red-600 tw-block">{{ errors.agree_terms_conditions }}</span>
                        </div>
                        <div class="tw-float-left">
                            <span class="tw-text-white">{{ __('terms.agree_checkbox') }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script setup lang="ts">
import { getCurrentInstance } from "vue";
import { useForm, useField } from "vee-validate";
import * as yup from "yup";

const emit = defineEmits<{
    "previous-component": [];
    "next-component": [];
}>();

const instance = getCurrentInstance();
const __ = instance?.appContext.config.globalProperties.__;

// Create validation schema
const validationSchema = yup.object({
    agree_terms_conditions: yup
        .boolean()
        .required(__('purchase.validation.accepted', { field: __('purchase.field_names.terms_accepted') }))
        .oneOf([true], __('purchase.validation.accepted', { field: __('purchase.field_names.terms_accepted') })),
});

// Setup form validation
const { handleSubmit, errors } = useForm({
    validationSchema,
    validateOnMount: false,
});

// Use field for checkbox
const { value: agreeTermsConditions } = useField<boolean>("agree_terms_conditions");

// Form submission handler
const formWillSubmit = handleSubmit(() => {
    emit("next-component");
}, () => {
    // Handle validation errors - scroll to error
    const errorElement = document.querySelector(".tw-border-red-500");
    if (errorElement) {
        errorElement.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
});

// Back button handler
const backBtnDidClick = () => {
    emit("previous-component");
};

// Expose methods for parent component access
defineExpose({
    backBtnDidClick,
    formWillSubmit,
});</script>

